import React, { FC, useEffect, useState } from 'react'

import style from '@root-gipro/modules/AdminPanel/styles/adminPanel.module.scss'

import { Button } from '@material-ui/core'
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles'
import { Routes } from '@root-gipro/router'
import { useDispatch } from 'react-redux'
import { NavLink, Redirect, Route, Switch } from 'react-router-dom'
import { getDeflators } from '../userProjects/store/actions'
import AdminPanelCompany from './components/AdminCompanies/AdminPanelCompany'
import AdminPanel from './components/AdminPanel/AdminPanel'
import AdminSettings from './components/AdminSettings/AdminSettings'
import { ROLE_DEVELOPER, ROLE_SUPERADMIN } from './store/helpers'
import AdminSolutions from './components/AdminSolutions/AdminSolutions'
import { ROSSETI_ID } from '../userProjects/utils/helpers'
import AdminObjectsAnalog from '@root-gipro/modules/AdminPanel/components/AdminObjectsAnalog/AdminObjectsAnalog'

const drawerWidth = 256

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			margin: '0 auto',
			maxWidth: '1280px',
			padding: 0,
		},
		drawer: {
			[theme.breakpoints.up('sm')]: {
				width: drawerWidth,
				flexShrink: 0,
			},
		},
		appBar: {
			[theme.breakpoints.up('sm')]: {
				width: `calc(100% - ${drawerWidth}px)`,
				marginLeft: drawerWidth,
			},
		},
		menuButton: {
			marginRight: theme.spacing(2),
			[theme.breakpoints.up('sm')]: {
				display: 'none',
			},
		},

		content: {
			flexGrow: 1,
			padding: theme.spacing(2),
		},
	})
)

const drawerList = [
	{ title: 'Пользователи', slug: 'users' },
	{ title: 'Компании', slug: 'companies' },
	{ title: 'Настройки', slug: 'settings' },
	{ title: 'Технические решения', slug: 'solutions' },
]

const objectsAnalogDrawer = { title: 'Объекты-аналоги', slug: 'objects-analog' };

const AdminContainer: FC = () => {
	const dispatch = useDispatch()
	const classes = useStyles()
	const [mobileOpen, setMobileOpen] = useState(false)
	const roleId = localStorage.getItem('roleId')
	const companyId = Number(localStorage.getItem('companyId'));

  const [isShowOA, setIsShowOA] = useState(false);

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen)
	}

	useEffect(() => {
		dispatch(getDeflators())
	}, [])

  useEffect(() => {
    if(roleId) {
      setIsShowOA(Number(roleId) === ROLE_DEVELOPER || Number(roleId) === ROLE_SUPERADMIN);
    }
  }, [roleId])

  return (
		<div className={classes.root}>
			<main className={classes.content}>
				<div className={style.navbar}>
					{drawerList.map(item => {
						if (
							(item.slug !== 'settings' || (item.slug === 'settings' && Number(roleId) === ROLE_DEVELOPER)) 
							&& (item.slug !== 'solutions' || (item.slug === 'solutions' && companyId === ROSSETI_ID))
						) {
							return (
								<Button
									key={item.title}
									component={NavLink}
									activeClassName={style.active}
									className={style.navLink}
									to={'/admin/' + item.slug}
								>
									{item.title}
								</Button>
							)
						}
					})}

          {isShowOA && (
            <Button
              key={objectsAnalogDrawer.title}
              component={NavLink}
              activeClassName={style.active}
              className={style.navLink}
              to={'/admin/' + objectsAnalogDrawer.slug}
            >
              {objectsAnalogDrawer.title}
            </Button>
          )}
        </div>
        
				<Switch>
					<Route path={Routes.ADMIN_USERS} component={AdminPanel} />
					<Route path={Routes.ADMIN_COMPANIES} component={AdminPanelCompany} />
					<Route path={Routes.ADMIN_SETTINGS} component={AdminSettings} />
					<Route path={Routes.ADMIN_SOLUTIONS} component={AdminSolutions} />

          {isShowOA && (
            <Route path={Routes.OBJECTS_ANALOG} component={AdminObjectsAnalog} />
          )}
          
					<Redirect from={Routes.ADMIN} to={Routes.ADMIN_USERS} />
				</Switch>
			</main>
		</div>
	)
}

export default AdminContainer
